<div *ngIf="!isMobile" [ngClass]="{
    'disable-div': !permissionsService.isRoleManagementCreateEditAllowed
  }">

  <!-- Dashboard -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
                PermissionsEnum.Dashboard_AnalyticsOverview,
                PermissionsEnum.Dashboard_OperationsAnalytics,
                PermissionsEnum.Dashboard_MeterValidation,
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.Dashboard_AnalyticsOverview,
                PermissionsEnum.Dashboard_OperationsAnalytics,
                PermissionsEnum.Dashboard_MeterValidation,            
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">Dashboard</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Dashboard_AnalyticsOverview])"
          (change)="onChangePermission([PermissionsEnum.Dashboard_AnalyticsOverview], $event)" />
        {{ "DASHBOARD.ANALYTICS_OVERVIEW.TITLE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Dashboard_OperationsAnalytics])" (change)="
            onChangePermission([PermissionsEnum.Dashboard_OperationsAnalytics], $event)
          " />
        {{ "DASHBOARD.OPERATIONS_ANALYTICS.TITLE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Dashboard_MeterValidation])" (change)="
            onChangePermission([PermissionsEnum.Dashboard_MeterValidation], $event)
          " />
        {{ "SIDENAV.METER_VALIDATION" | translate }}</label>
    </div>
  </div>
  <!-- Advanced Map -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMap">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.Map_View
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.Map_View,                
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          Map</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Map_View])" (change)="
          onChangePermission([PermissionsEnum.Map_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
    </div>
  </div>
  <!-- Customers -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigBuildings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Customer_View,
                PermissionsEnum.Customer_CreateEdit,
                PermissionsEnum.Customer_Delete,
                PermissionsEnum.Customer_AuditReview,
                PermissionsEnum.Customer_ApproveReject,
                PermissionsEnum.Customer_Assign,
                PermissionsEnum.Customer_RecallAssigned,
                PermissionsEnum.Customer_RecallValidated,
                PermissionsEnum.Customer_Retag,
                PermissionsEnum.Customer_Download,
                PermissionsEnum.Customer_Review,
                PermissionsEnum.Customer_NewEntryBreakdown,
                PermissionsEnum.Customer_Unvisited,
                PermissionsEnum.Customer_ElectricalAddressCode,
                PermissionsEnum.Customer_PropertyCode
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Customer_View,
                  PermissionsEnum.Customer_CreateEdit,
                  PermissionsEnum.Customer_Delete,
                  PermissionsEnum.Customer_AuditReview,
                  PermissionsEnum.Customer_ApproveReject,
                  PermissionsEnum.Customer_Assign,
                  PermissionsEnum.Customer_RecallAssigned,
                  PermissionsEnum.Customer_RecallValidated,
                  PermissionsEnum.Customer_Retag,
                  PermissionsEnum.Customer_Download,
                  PermissionsEnum.Customer_Review,
                  PermissionsEnum.Customer_NewEntryBreakdown,
                  PermissionsEnum.Customer_Unvisited,
                  PermissionsEnum.Customer_ElectricalAddressCode,
                  PermissionsEnum.Customer_PropertyCode
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.CUSTOMER.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_View])"
          (change)="onChangePermission([PermissionsEnum.Customer_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Customer_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_Delete])" (change)="
            onChangePermission([PermissionsEnum.Customer_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Unvisited])" (change)="
            onChangePermission([PermissionsEnum.Customer_Unvisited], $event)
          " />
        {{ "CUSTOMERS.UNVISITED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_NewEntryBreakdown])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_NewEntryBreakdown],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.NEW_ENTRY_BREAKDOWN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Assign])" (change)="
            onChangePermission([PermissionsEnum.Customer_Assign], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.Customer_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Review])" (change)="
            onChangePermission([PermissionsEnum.Customer_Review], $event)
          " />
        {{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_AuditReview])" (change)="
            onChangePermission([PermissionsEnum.Customer_AuditReview], $event)
          " />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_RecallAssigned])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_RecallAssigned],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_RecallValidated])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_RecallValidated],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Retag])" (change)="
            onChangePermission([PermissionsEnum.Customer_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="isRegularizationUploadVisible"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Regularization])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_Regularization],
              $event
            )
          " />
        {{ "COMMON.REGULARIZATION" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Download])" (change)="
            onChangePermission([PermissionsEnum.Customer_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_ElectricalAddressCode])" (change)="
            onChangePermission([PermissionsEnum.Customer_ElectricalAddressCode], $event)
          " />
        {{ "COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_PropertyCode])" (change)="
            onChangePermission([PermissionsEnum.Customer_PropertyCode], $event)
          " />
        {{ "COMMON.MBC_DETAILS.PROPERTY_CODE" | translate }}</label>
    </div>
  </div>
  <div class="component" *ngIf="permissionsService.hasDashboardConfigBuildings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Customer_ViewCrud,
                PermissionsEnum.Customer_CreateEditCrud,
                PermissionsEnum.Customer_AssignForDecommission,
                PermissionsEnum.Customer_CrudDownload,
                PermissionsEnum.Customer_ServiceRequestViewCrud,
                PermissionsEnum.Customer_NewEntryViewCrud,
                PermissionsEnum.Customer_FailedSyncNotification,
                PermissionsEnum.Customer_FeederBandAlignmentNotification
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Customer_ViewCrud,
                  PermissionsEnum.Customer_CreateEditCrud,
                  PermissionsEnum.Customer_AssignForDecommission,
                  PermissionsEnum.Customer_CrudDownload,
                  PermissionsEnum.Customer_ServiceRequestViewCrud,
                  PermissionsEnum.Customer_NewEntryViewCrud,
                  PermissionsEnum.Customer_FailedSyncNotification,
                  PermissionsEnum.Customer_FeederBandAlignmentNotification
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.CUSTOMER.PLURAL" | translate }}
          {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_ViewCrud])" (change)="
            onChangePermission([PermissionsEnum.Customer_ViewCrud], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_CreateEditCrud])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_CreateEditCrud],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}
      </label>
      <label><input type="checkbox" [checked]="
            isChecked([PermissionsEnum.Customer_AssignForDecommission])
          " (change)="
            onChangePermission(
              [PermissionsEnum.Customer_AssignForDecommission],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN_FOR_DECOMMISIONING" | translate }}
      </label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_CrudDownload])" (change)="
            onChangePermission([PermissionsEnum.Customer_CrudDownload], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_ServiceRequestViewCrud])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_ServiceRequestViewCrud],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.SERVICE_REQUEST" | translate }}
      </label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_NewEntryViewCrud])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_NewEntryViewCrud],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.NEW_ENTRY" | translate }}
      </label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_FailedSyncNotification])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_FailedSyncNotification],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.FAILED_SYNC_NOTIFICATION" | translate }}
      </label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_FeederBandAlignmentNotification])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_FeederBandAlignmentNotification],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.FEEDER_BAND_ALIGNMENT_NOTIFICATION" | translate }}
      </label>
    </div>
  </div>

  <!-- AI UAV -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigAIDroneMap">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.AI_UAV_Overview,
              PermissionsEnum.AI_UAV_Batch_Image_Import,
              PermissionsEnum.AI_UAV_Segmentation_List,
              PermissionsEnum.AI_UAV_Job_Monitoring
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.AI_UAV_Overview,
                PermissionsEnum.AI_UAV_Batch_Image_Import,
                PermissionsEnum.AI_UAV_Segmentation_List,
                PermissionsEnum.AI_UAV_Job_Monitoring              
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.AI_UAV' | translate | uppercase}}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AI_UAV_Overview])" (change)="
          onChangePermission([PermissionsEnum.AI_UAV_Overview], $event)
        " />
        {{ "ROLE_MANAGEMENT.OVERVIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AI_UAV_Batch_Image_Import])" (change)="
          onChangePermission([PermissionsEnum.AI_UAV_Batch_Image_Import], $event)
        " />
        {{ "ROLE_MANAGEMENT.BATCH_IMAGE_IMPORT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AI_UAV_Segmentation_List])" (change)="
          onChangePermission([PermissionsEnum.AI_UAV_Segmentation_List], $event)
        " />
        {{ "ROLE_MANAGEMENT.SEGMENTATION_LIST" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AI_UAV_Job_Monitoring])" (change)="
          onChangePermission([PermissionsEnum.AI_UAV_Job_Monitoring], $event)
        " />
        {{ "ROLE_MANAGEMENT.JOB_MONITORING" | translate }}</label>
    </div>
  </div>

  <!-- Transformers -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigDTS">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Transformers_View,
                PermissionsEnum.Transformers_CreateEdit,
                PermissionsEnum.Transformers_CreateEditCrud,
                PermissionsEnum.Transformers_ViewCrud,
                PermissionsEnum.Transformers_Delete,
                PermissionsEnum.Transformers_Assign,
                PermissionsEnum.Transformers_ApproveReject,
                PermissionsEnum.Transformers_AuditReview,
                PermissionsEnum.Transformers_Review,
                PermissionsEnum.Transformers_RecallAssigned,
                PermissionsEnum.Transformers_RecallValidated,
                PermissionsEnum.Transformers_Retag,
                PermissionsEnum.Transformers_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Transformers_View,
                  PermissionsEnum.Transformers_ViewCrud,
                  PermissionsEnum.Transformers_CreateEditCrud,
                  PermissionsEnum.Transformers_CreateEdit,
                  PermissionsEnum.Transformers_Delete,
                  PermissionsEnum.Transformers_Assign,
                  PermissionsEnum.Transformers_ApproveReject,
                  PermissionsEnum.Transformers_AuditReview,
                  PermissionsEnum.Transformers_Review,
                  PermissionsEnum.Transformers_RecallAssigned,
                  PermissionsEnum.Transformers_RecallValidated,
                  PermissionsEnum.Transformers_Retag,
                  PermissionsEnum.Transformers_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.TRANSFORMER.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_View])" (change)="
            onChangePermission([PermissionsEnum.Transformers_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_ViewCrud])" (change)="
            onChangePermission([PermissionsEnum.Transformers_ViewCrud], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}
        {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_CreateEditCrud])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_CreateEditCrud],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}
        {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_Delete])" (change)="
            onChangePermission([PermissionsEnum.Transformers_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_Assign])" (change)="
            onChangePermission([PermissionsEnum.Transformers_Assign], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_ApproveReject])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_ApproveReject],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_Review])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_Review],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_AuditReview])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_AuditReview],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_RecallAssigned])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_RecallAssigned],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_RecallValidated])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_RecallValidated],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_Retag])" (change)="
            onChangePermission([PermissionsEnum.Transformers_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Transformers_Download])" (change)="
            onChangePermission([PermissionsEnum.Transformers_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- Rmus -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigRmus">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Rmus_View,
                PermissionsEnum.Rmus_ViewCrud,
                PermissionsEnum.Rmus_CreateEdit,
                PermissionsEnum.Rmus_CreateEditCrud,
                PermissionsEnum.Rmus_Delete,
                PermissionsEnum.Rmus_Assign,
                PermissionsEnum.Rmus_ApproveReject,
                PermissionsEnum.Rmus_AuditReview,
                PermissionsEnum.Rmus_RecallAssigned,
                PermissionsEnum.Rmus_RecallValidated,
                PermissionsEnum.Rmus_Retag,
                PermissionsEnum.Rmus_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Rmus_View,
                  PermissionsEnum.Rmus_ViewCrud,
                  PermissionsEnum.Rmus_CreateEdit,
                  PermissionsEnum.Rmus_CreateEditCrud,
                  PermissionsEnum.Rmus_Delete,
                  PermissionsEnum.Rmus_Assign,
                  PermissionsEnum.Rmus_ApproveReject,
                  PermissionsEnum.Rmus_AuditReview,
                  PermissionsEnum.Rmus_RecallAssigned,
                  PermissionsEnum.Rmus_RecallValidated,
                  PermissionsEnum.Rmus_Retag,
                  PermissionsEnum.Rmus_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "RMU.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_View])" (change)="
            onChangePermission([PermissionsEnum.Rmus_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_ViewCrud])" (change)="
            onChangePermission([PermissionsEnum.Rmus_ViewCrud], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}
        {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_CreateEditCrud])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_CreateEditCrud],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}
        {{ "ROLE_MANAGEMENT.CRUD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_Delete])" (change)="
            onChangePermission([PermissionsEnum.Rmus_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_Assign])" (change)="
            onChangePermission([PermissionsEnum.Rmus_Assign], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_ApproveReject])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_ApproveReject],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_AuditReview])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_AuditReview],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_RecallAssigned])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_RecallAssigned],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_RecallValidated])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_RecallValidated],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_Retag])" (change)="
            onChangePermission([PermissionsEnum.Rmus_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigDTS"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Rmus_Download])" (change)="
            onChangePermission([PermissionsEnum.Rmus_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>

  <!-- Poles -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigPoles">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Pole_View,
                PermissionsEnum.Pole_CreateEdit,
                PermissionsEnum.Pole_Delete,
                PermissionsEnum.Pole_Assign,
                PermissionsEnum.Pole_ApproveReject,
                PermissionsEnum.Pole_AuditReview,
                PermissionsEnum.Pole_Review,
                PermissionsEnum.Pole_RecallAssigned,
                PermissionsEnum.Pole_RecallValidated,
                PermissionsEnum.Pole_Retag,
                PermissionsEnum.Pole_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Pole_View,
                  PermissionsEnum.Pole_CreateEdit,
                  PermissionsEnum.Pole_Delete,
                  PermissionsEnum.Pole_Assign,
                  PermissionsEnum.Pole_ApproveReject,
                  PermissionsEnum.Pole_AuditReview,
                  PermissionsEnum.Pole_Review,
                  PermissionsEnum.Pole_RecallAssigned,
                  PermissionsEnum.Pole_RecallValidated,
                  PermissionsEnum.Pole_Retag,
                  PermissionsEnum.Pole_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.POLE.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_View])"
          (change)="onChangePermission([PermissionsEnum.Pole_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Pole_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_Delete])"
          (change)="onChangePermission([PermissionsEnum.Pole_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_Assign])"
          (change)="onChangePermission([PermissionsEnum.Pole_Assign], $event)" />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.Pole_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_Review])" (change)="
            onChangePermission([PermissionsEnum.Pole_Review], $event)
          " />
        {{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_AuditReview])" (change)="
              onChangePermission([PermissionsEnum.Pole_AuditReview], $event)
            " />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_RecallAssigned])" (change)="
            onChangePermission([PermissionsEnum.Pole_RecallAssigned], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_RecallValidated])" (change)="
            onChangePermission([PermissionsEnum.Pole_RecallValidated], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_Retag])"
          (change)="onChangePermission([PermissionsEnum.Pole_Retag], $event)" />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigPoles"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Pole_Download])" (change)="
            onChangePermission([PermissionsEnum.Pole_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- MV Poles -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMVPoles && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.MVPole_View,
                PermissionsEnum.MVPole_CreateEdit,
                PermissionsEnum.MVPole_Delete,
                PermissionsEnum.MVPole_Assign,
                PermissionsEnum.MVPole_ApproveReject,
                PermissionsEnum.MVPole_AuditReview,
                PermissionsEnum.MVPole_RecallAssigned,
                PermissionsEnum.MVPole_Retag,
                PermissionsEnum.MVPole_RecallValidated,
                PermissionsEnum.MVPole_Download

              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.MVPole_View,
                  PermissionsEnum.MVPole_CreateEdit,
                  PermissionsEnum.MVPole_Delete,
                  PermissionsEnum.MVPole_Assign,
                  PermissionsEnum.MVPole_ApproveReject,
                  PermissionsEnum.MVPole_AuditReview,
                  PermissionsEnum.MVPole_RecallAssigned,
                  PermissionsEnum.MVPole_Retag,
                  PermissionsEnum.MVPole_RecallValidated,
                  PermissionsEnum.MVPole_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">MV Poles</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_View])"
          (change)="onChangePermission([PermissionsEnum.MVPole_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_CreateEdit])"
          (change)="onChangePermission([PermissionsEnum.MVPole_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Delete])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Delete], $event)" />
        {{ "ROLE_MANAGEMENT.DELETE" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Assign])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Assign], $event)" />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_ApproveReject])"
          (change)="onChangePermission([PermissionsEnum.MVPole_ApproveReject], $event)" />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_AuditReview])"
          (change)="onChangePermission([PermissionsEnum.MVPole_AuditReview], $event)" />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_RecallAssigned])"
          (change)="onChangePermission([PermissionsEnum.MVPole_RecallAssigned], $event)" />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Retag])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Retag], $event)" />
        {{ "ROLE_MANAGEMENT.RETAG" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_RecallValidated])"
          (change)="onChangePermission([PermissionsEnum.MVPole_RecallValidated], $event)" />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Download])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Download], $event)" />
        {{ "ROLE_MANAGEMENT.DOWNLOAD" | translate }}
      </label>
    </div>
  </div>
  <!-- Buildings -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigBuildings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Building_View,
                PermissionsEnum.Building_CreateEdit,
                PermissionsEnum.Building_Delete,
                PermissionsEnum.Building_Assign,
                PermissionsEnum.Building_ApproveReject,
                PermissionsEnum.Building_AuditReview,
                PermissionsEnum.Building_RecallAssigned,
                PermissionsEnum.Building_RecallValidated,
                PermissionsEnum.Building_Retag,
                PermissionsEnum.Building_Download,
                PermissionsEnum.Building_Review,
                PermissionsEnum.Building_ElectricalAddressCode,
                PermissionsEnum.Building_PropertyCode
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Building_View,
                  PermissionsEnum.Building_CreateEdit,
                  PermissionsEnum.Building_Delete,
                  PermissionsEnum.Building_Assign,
                  PermissionsEnum.Building_ApproveReject,
                  PermissionsEnum.Building_AuditReview,
                  PermissionsEnum.Building_RecallAssigned,
                  PermissionsEnum.Building_RecallValidated,
                  PermissionsEnum.Building_Retag,
                  PermissionsEnum.Building_Download,
                  PermissionsEnum.Building_Review,
                  PermissionsEnum.Building_ElectricalAddressCode,
                  PermissionsEnum.Building_PropertyCode
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.BUILDING.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_View])"
          (change)="onChangePermission([PermissionsEnum.Building_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Building_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_Delete])" (change)="
            onChangePermission([PermissionsEnum.Building_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_Assign])" (change)="
            onChangePermission([PermissionsEnum.Building_Assign], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.Building_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_Review])" (change)="
            onChangePermission([PermissionsEnum.Building_Review], $event)
          " />
        {{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_AuditReview])" (change)="
            onChangePermission([PermissionsEnum.Building_AuditReview], $event)
          " />
        Audit Review</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_RecallAssigned])" (change)="
            onChangePermission(
              [PermissionsEnum.Building_RecallAssigned],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_RecallValidated])" (change)="
            onChangePermission(
              [PermissionsEnum.Building_RecallValidated],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_Retag])" (change)="
            onChangePermission([PermissionsEnum.Building_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_Download])" (change)="
            onChangePermission([PermissionsEnum.Building_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_ElectricalAddressCode])" (change)="
            onChangePermission([PermissionsEnum.Building_ElectricalAddressCode], $event)
          " />
        {{ "COMMON.MBC_DETAILS.ELECTRICAL_ADDRESS" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigBuildings"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Building_PropertyCode])" (change)="
            onChangePermission([PermissionsEnum.Building_PropertyCode], $event)
          " />
        {{ "COMMON.MBC_DETAILS.PROPERTY_CODE" | translate }}</label>
    </div>
  </div>
  <!-- Meters -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeters">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Meters_View,
                PermissionsEnum.Meters_CreateEdit,
                PermissionsEnum.Meters_Delete,
                PermissionsEnum.Meters_ApproveReject,
                PermissionsEnum.Meters_Retag,
                PermissionsEnum.Meters_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Meters_View,
                  PermissionsEnum.Meters_CreateEdit,
                  PermissionsEnum.Meters_Delete,
                  PermissionsEnum.Meters_ApproveReject,
                  PermissionsEnum.Meters_Retag,
                  PermissionsEnum.Meters_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "METERS.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_View])"
          (change)="onChangePermission([PermissionsEnum.Meters_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Meters_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_Delete])"
          (change)="onChangePermission([PermissionsEnum.Meters_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigMeters"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Meters_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.Meters_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigMeters"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Meters_Retag])"
          (change)="onChangePermission([PermissionsEnum.Meters_Retag], $event)" />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="permissionsService.hasDashboardConfigMeters"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Meters_Download])" (change)="
            onChangePermission([PermissionsEnum.Meters_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- Service Request -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNewService">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.NewService_View,
                PermissionsEnum.NewService_CreateEdit,
                PermissionsEnum.NewService_Download,
                PermissionsEnum.NewService_BulkUpload,
                PermissionsEnum.NewService_ApproveReject,
                PermissionsEnum.NewService_RecallValidated,
                PermissionsEnum.NewService_HighCapacity,
                PermissionsEnum.NewService_StandardCapacity
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.NewService_View,
                  PermissionsEnum.NewService_CreateEdit,
                  PermissionsEnum.NewService_Download,
                  PermissionsEnum.NewService_BulkUpload,
                  PermissionsEnum.NewService_ApproveReject,
                  PermissionsEnum.NewService_RecallValidated,
                  PermissionsEnum.NewService_HighCapacity,
                  PermissionsEnum.NewService_StandardCapacity
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "HEADER_TITLE.SERVICE_REQUEST" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_View])" (change)="
            onChangePermission([PermissionsEnum.NewService_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.NewService_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_Download])" (change)="
            onChangePermission([PermissionsEnum.NewService_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_BulkUpload])" (change)="
            onChangePermission([PermissionsEnum.NewService_BulkUpload], $event)
          " />
        {{ "ROLE_MANAGEMENT.SERVICE_REQUEST_BULK_UPLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.NewService_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.VALIDATION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_RecallValidated])" (change)="
            onChangePermission([PermissionsEnum.NewService_RecallValidated], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_HighCapacity])" (change)="
            onChangePermission([PermissionsEnum.NewService_HighCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NewService_StandardCapacity])" (change)="
            onChangePermission([PermissionsEnum.NewService_StandardCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
    </div>
  </div>
  <!-- Site Verification -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNewService">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.SiteVerification_View,
                PermissionsEnum.SiteVerification_CreateEdit,
                PermissionsEnum.SiteVerification_Download,
                PermissionsEnum.SiteVerification_Validation,
                PermissionsEnum.SiteVerification_RecallAssigned,
                PermissionsEnum.SiteVerification_RecallValidated,
                PermissionsEnum.SiteVerification_SiteVerification,
                PermissionsEnum.SiteVerification_HighCapacity,
                PermissionsEnum.SiteVerification_StandardCapacity
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.SiteVerification_View,
                  PermissionsEnum.SiteVerification_CreateEdit,
                  PermissionsEnum.SiteVerification_Download,
                  PermissionsEnum.SiteVerification_Validation,
                  PermissionsEnum.SiteVerification_RecallAssigned,
                  PermissionsEnum.SiteVerification_RecallValidated,
                  PermissionsEnum.SiteVerification_SiteVerification,
                  PermissionsEnum.SiteVerification_HighCapacity,
                  PermissionsEnum.SiteVerification_StandardCapacity
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_View])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_Download])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_Validation])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_Validation], $event)
          " />
        {{ "ROLE_MANAGEMENT.VALIDATION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_RecallAssigned])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_RecallAssigned], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_RecallValidated])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_RecallValidated], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_SiteVerification])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_SiteVerification], $event)
          " />
        {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_HighCapacity])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_HighCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_StandardCapacity])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_StandardCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
    </div>
  </div>
  <!-- Service Request Authorization -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNewService">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.ServiceRequestAuth_View,
                PermissionsEnum.ServiceRequestAuth_CreateEdit,
                PermissionsEnum.ServiceRequestAuth_Download,
                PermissionsEnum.ServiceRequestAuth_BulkUpload,
                PermissionsEnum.ServiceRequestAuth_Validation,
                PermissionsEnum.ServiceRequestAuth_HighCapacity,
                PermissionsEnum.ServiceRequestAuth_StandardCapacity
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.ServiceRequestAuth_View,
                  PermissionsEnum.ServiceRequestAuth_CreateEdit,
                  PermissionsEnum.ServiceRequestAuth_Download,
                  PermissionsEnum.ServiceRequestAuth_BulkUpload,
                  PermissionsEnum.ServiceRequestAuth_Validation,
                  PermissionsEnum.ServiceRequestAuth_HighCapacity,
                  PermissionsEnum.ServiceRequestAuth_StandardCapacity
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "ROLE_MANAGEMENT.SERVICE_CONNECTION_CHARGES" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_View])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_Download])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_BulkUpload])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_BulkUpload], $event)
          " />
        {{ "ROLE_MANAGEMENT.SERVICE_REQUEST_AUTH_BULK_UPLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_Validation])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_Validation], $event)
          " />
        {{ "ROLE_MANAGEMENT.VALIDATION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_HighCapacity])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_HighCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestAuth_StandardCapacity])"
          (change)="
            onChangePermission([PermissionsEnum.ServiceRequestAuth_StandardCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
    </div>
  </div>
  <!-- Onboarded Customers -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNewService">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.OnboardedCustomers_View,
                PermissionsEnum.OnboardedCustomers_CreateEdit,
                PermissionsEnum.OnboardedCustomers_Download,
                PermissionsEnum.OnboardedCustomers_AssignToVendor,
                PermissionsEnum.OnboardedCustomers_HighCapacity,
                PermissionsEnum.OnboardedCustomers_StandardCapacity
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.OnboardedCustomers_View,
                  PermissionsEnum.OnboardedCustomers_CreateEdit,
                  PermissionsEnum.OnboardedCustomers_Download,
                  PermissionsEnum.OnboardedCustomers_AssignToVendor,
                  PermissionsEnum.OnboardedCustomers_HighCapacity,
                  PermissionsEnum.OnboardedCustomers_StandardCapacity
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "HEADER_TITLE.ONBOARDED_CUSTOMERS" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_View])" (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_Download])" (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_AssignToVendor])" (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_AssignToVendor], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN_TO_VENDOR" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_HighCapacity])" (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_HighCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.HIGH_CAPACITY' | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.OnboardedCustomers_StandardCapacity])"
          (change)="
            onChangePermission([PermissionsEnum.OnboardedCustomers_StandardCapacity], $event)
          " />
        {{ 'ROLE_MANAGEMENT.STANDARD_CAPACITY' | translate }}</label>
    </div>
  </div>
  <!-- Service Request Tracker -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNewService">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.ServiceRequestTracker_View
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.ServiceRequestTracker_View
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "HEADER_TITLE.SERVICE_REQUEST_TRACKER" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.ServiceRequestTracker_View])" (change)="
            onChangePermission([PermissionsEnum.ServiceRequestTracker_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
    </div>
  </div>
  <!-- Survey -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigSurvey">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Survey_View,
                PermissionsEnum.Survey_CreateEdit,
                PermissionsEnum.Survey_Delete,
                PermissionsEnum.Survey_ApproveReject,
                PermissionsEnum.Survey_RecallApproved,
                PermissionsEnum.Survey_RecallRejected,
                PermissionsEnum.Survey_AssignMapVendor,
                PermissionsEnum.Survey_AssignToVendor
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Survey_View,
                  PermissionsEnum.Survey_CreateEdit,
                  PermissionsEnum.Survey_Delete,
                  PermissionsEnum.Survey_ApproveReject,
                  PermissionsEnum.Survey_RecallApproved,
                  PermissionsEnum.Survey_RecallRejected,
                  PermissionsEnum.Survey_AssignMapVendor,
                  PermissionsEnum.Survey_AssignToVendor
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_View])"
          (change)="onChangePermission([PermissionsEnum.Survey_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Survey_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_Delete])"
          (change)="onChangePermission([PermissionsEnum.Survey_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_ApproveReject])" (change)="
            onChangePermission([PermissionsEnum.Survey_ApproveReject], $event)
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_RecallApproved])" (change)="
            onChangePermission([PermissionsEnum.Survey_RecallApproved], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_APPROVED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_RecallRejected])" (change)="
            onChangePermission([PermissionsEnum.Survey_RecallRejected], $event)
          " />
        {{ "ROLE_MANAGEMENT.RECALL_REJECTED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_AssignMapVendor])" (change)="
            onChangePermission([PermissionsEnum.Survey_AssignMapVendor], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN_MAP_VENDOR" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_AssignToVendor])" (change)="
            onChangePermission([PermissionsEnum.Survey_AssignToVendor], $event)
          " />
        {{ "ROLE_MANAGEMENT.ASSIGN_TO_VENDOR" | translate }}</label>
    </div>
  </div>
  <!-- Customer Installation -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigInstallation">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Installation_View,
                PermissionsEnum.Installation_CreateEdit,
                PermissionsEnum.Installation_Delete,
                PermissionsEnum.Installation_ApproveReject,
                PermissionsEnum.Installation_Recall
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Installation_View,
                  PermissionsEnum.Installation_CreateEdit,
                  PermissionsEnum.Installation_Delete,
                  PermissionsEnum.Installation_ApproveReject,
                  PermissionsEnum.Installation_Recall
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.CUSTOMER_INSTALLATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_View])" (change)="
            onChangePermission([PermissionsEnum.Installation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Installation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_Delete])" (change)="
            onChangePermission([PermissionsEnum.Installation_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_ApproveReject])" (change)="
            onChangePermission(
              [PermissionsEnum.Installation_ApproveReject],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>

      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_Recall])" (change)="
            onChangePermission(
              [PermissionsEnum.Installation_Recall],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL" | translate }}</label>
    </div>
  </div>

  <!-- DT Meter Installation -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigDtMeterInstallation">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked(dtMeterInstallationPermissions)" (change)="
              onChangePermission(dtMeterInstallationPermissions, $event)
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.DT_METER_INSTALLATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_View])" (change)="
            onChangePermission([PermissionsEnum.DtMeterInstallation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_Delete])" (change)="
            onChangePermission([PermissionsEnum.DtMeterInstallation_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveReject])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ApproveReject],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_Recall])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_Recall],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AuthorizeMetering])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_AuthorizeMetering],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.AUTHORIZE_METERING" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_VendorAssignment])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_VendorAssignment],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VENDOR_ASSIGNMENT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_DeclineReport])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_DeclineReport],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.DECLINE_REPORT" | translate }}</label>
    </div>
    <div class="permissionsComponent subGroup" *ngIf="permissionsService.hasDashboardConfigMeterApprovalAndRepayment">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AcceptDecline])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_AcceptDecline],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.ACCEPT_AND_DECLINE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveMeter])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ApproveMeter],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_METER" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ApproveInvoice])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ApproveInvoice],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_INVOICE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_RecallAwaitingApproval],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.RECALL_AWAITING_APPROVAL" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_AcknowledgeRepayment],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.ACKNOWLEDGE_REPAYMENT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewMeterApproval])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ViewMeterApproval],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_METER_APPROVAL" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ViewInvoiceApproval],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_INVOICE_APPROVAL" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewActiveRepayment])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ViewActiveRepayment],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_ACTIVE_REPAYMENT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_ViewCompletedPayment])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_ViewCompletedPayment],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_COMPLETED_PAYMENT" | translate }}</label>
    </div>
  </div>
  <!-- Meter Validation -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeterValidation">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Meter_Validation_View,
                PermissionsEnum.Meter_Validation_CreateEdit,
                PermissionsEnum.Meter_Validation_ApproveReject,
              ])
            " (change)="
              onChangePermission(
                [
                PermissionsEnum.Meter_Validation_View,
                PermissionsEnum.Meter_Validation_CreateEdit,
                PermissionsEnum.Meter_Validation_ApproveReject,
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "SIDENAV.METER_VALIDATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meter_Validation_View])" (change)="
            onChangePermission([PermissionsEnum.Meter_Validation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meter_Validation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Meter_Validation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meter_Validation_ApproveReject])" (change)="
            onChangePermission(
              [PermissionsEnum.Meter_Validation_ApproveReject],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
    </div>
  </div>
  <!-- Report -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigInstallation">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Report_Misaligned,
                PermissionsEnum.Report_DataQualityRejection,
                PermissionsEnum.Report_Regularization
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Report_Misaligned,
                  PermissionsEnum.Report_DataQualityRejection,
                  PermissionsEnum.Report_Regularization
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.REPORTS" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Report_Misaligned])" (change)="
            onChangePermission([PermissionsEnum.Report_Misaligned], $event)
          " />
        {{ "COMMON.MISALIGNED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Report_DataQualityRejection])" (change)="
            onChangePermission(
              [PermissionsEnum.Report_DataQualityRejection],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.DATA_QUALITY_REJECTION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Report_Regularization])" (change)="
            onChangePermission([PermissionsEnum.Report_Regularization], $event)
          " />
        {{ "COMMON.REGULARIZATION" | translate }}</label>
    </div>
  </div>

  <!-- Readings -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigReadings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.Readings_View
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.Readings_View           
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.READINGS' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Readings_View])" (change)="
          onChangePermission([PermissionsEnum.Readings_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
    </div>
  </div>

  <!-- User Management -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.UserManagement_View,
                PermissionsEnum.UserManagement_CreateEdit,
                PermissionsEnum.UserManagement_Delete,
                PermissionsEnum.UserManagement_BulkAssign,
                PermissionsEnum.UserManagement_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.UserManagement_View,
                  PermissionsEnum.UserManagement_CreateEdit,
                  PermissionsEnum.UserManagement_Delete,
                  PermissionsEnum.UserManagement_BulkAssign,
                  PermissionsEnum.UserManagement_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.USER_MANAGEMENT" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.UserManagement_View])" (change)="
            onChangePermission([PermissionsEnum.UserManagement_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.UserManagement_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.UserManagement_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.UserManagement_Delete])" (change)="
            onChangePermission([PermissionsEnum.UserManagement_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.UserManagement_BulkAssign])" (change)="
            onChangePermission(
              [PermissionsEnum.UserManagement_BulkAssign],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.BULK_ASSIGN" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.UserManagement_Download])" (change)="
            onChangePermission([PermissionsEnum.UserManagement_Download], $event)
          " />
        {{ "ROLE_MANAGEMENT.DOWNLOAD" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Organization_Create])" (change)="
            onChangePermission([PermissionsEnum.Organization_Create], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_ORGANIZATION" | translate }}</label>
    </div>
  </div>
  <!-- Role Management -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.RoleManagement_View,
                PermissionsEnum.RoleManagement_CreateEdit,
                PermissionsEnum.RoleManagement_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.RoleManagement_View,
                  PermissionsEnum.RoleManagement_CreateEdit,
                  PermissionsEnum.RoleManagement_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.ROLE_MANAGER" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.RoleManagement_View])" (change)="
            onChangePermission([PermissionsEnum.RoleManagement_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.RoleManagement_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.RoleManagement_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.RoleManagement_Delete])" (change)="
            onChangePermission([PermissionsEnum.RoleManagement_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Transmission station -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Ts_View,
                PermissionsEnum.Ts_CreateEdit,
                PermissionsEnum.Ts_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Ts_View,
                  PermissionsEnum.Ts_CreateEdit,
                  PermissionsEnum.Ts_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.TS.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ts_View])"
          (change)="onChangePermission([PermissionsEnum.Ts_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ts_CreateEdit])"
          (change)="onChangePermission([PermissionsEnum.Ts_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ts_Delete])"
          (change)="onChangePermission([PermissionsEnum.Ts_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Main Feeder -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigFeeders">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.F33_View,
                PermissionsEnum.F33_CreateEdit,
                PermissionsEnum.F33_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.F33_View,
                  PermissionsEnum.F33_CreateEdit,
                  PermissionsEnum.F33_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.MBC_DETAILS.MAIN_FEEDER" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F33_View])"
          (change)="onChangePermission([PermissionsEnum.F33_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F33_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.F33_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F33_Delete])"
          (change)="onChangePermission([PermissionsEnum.F33_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- SS -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Ss_View,
                PermissionsEnum.Ss_CreateEdit,
                PermissionsEnum.Ss_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Ss_View,
                  PermissionsEnum.Ss_CreateEdit,
                  PermissionsEnum.Ss_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.SS.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ss_View])"
          (change)="onChangePermission([PermissionsEnum.Ss_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ss_CreateEdit])"
          (change)="onChangePermission([PermissionsEnum.Ss_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Ss_Delete])"
          (change)="onChangePermission([PermissionsEnum.Ss_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- F11 -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigFeeders">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.F11_View,
                PermissionsEnum.F11_CreateEdit,
                PermissionsEnum.F11_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.F11_View,
                  PermissionsEnum.F11_CreateEdit,
                  PermissionsEnum.F11_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.MBC_DETAILS.SUB_FEEDER" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F11_View])"
          (change)="onChangePermission([PermissionsEnum.F11_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F11_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.F11_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.F11_Delete])"
          (change)="onChangePermission([PermissionsEnum.F11_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Area -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Area_View,
                PermissionsEnum.Area_CreateEdit,
                PermissionsEnum.Area_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Area_View,
                  PermissionsEnum.Area_CreateEdit,
                  PermissionsEnum.Area_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.UT.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Area_View])"
          (change)="onChangePermission([PermissionsEnum.Area_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Area_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Area_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Area_Delete])"
          (change)="onChangePermission([PermissionsEnum.Area_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Region -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Region_View,
                PermissionsEnum.Region_CreateEdit,
                PermissionsEnum.Region_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Region_View,
                  PermissionsEnum.Region_CreateEdit,
                  PermissionsEnum.Region_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.BU.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Region_View])"
          (change)="onChangePermission([PermissionsEnum.Region_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Region_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Region_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Region_Delete])"
          (change)="onChangePermission([PermissionsEnum.Region_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Tariff -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Tariff_View,
                PermissionsEnum.Tariff_CreateEdit,
                PermissionsEnum.Tariff_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Tariff_View,
                  PermissionsEnum.Tariff_CreateEdit,
                  PermissionsEnum.Tariff_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.TARIFF.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Tariff_View])"
          (change)="onChangePermission([PermissionsEnum.Tariff_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Tariff_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Tariff_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Tariff_Delete])"
          (change)="onChangePermission([PermissionsEnum.Tariff_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Meter type -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.MeterType_View,
                PermissionsEnum.MeterType_CreateEdit,
                PermissionsEnum.MeterType_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.MeterType_View,
                  PermissionsEnum.MeterType_CreateEdit,
                  PermissionsEnum.MeterType_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.MBC_DETAILS.METER_TYPE.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterType_View])" (change)="
            onChangePermission([PermissionsEnum.MeterType_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterType_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.MeterType_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterType_Delete])" (change)="
            onChangePermission([PermissionsEnum.MeterType_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- AssetRating -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.AssetRating_View,
                PermissionsEnum.AssetRating_CreateEdit,
                PermissionsEnum.AssetRating_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.AssetRating_View,
                  PermissionsEnum.AssetRating_CreateEdit,
                  PermissionsEnum.AssetRating_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.ASSET_RATING.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetRating_View])" (change)="
            onChangePermission([PermissionsEnum.AssetRating_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetRating_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.AssetRating_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetRating_Delete])" (change)="
            onChangePermission([PermissionsEnum.AssetRating_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- AssetStatus -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.AssetStatus_View,
                PermissionsEnum.AssetStatus_CreateEdit,
                PermissionsEnum.AssetStatus_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.AssetStatus_View,
                  PermissionsEnum.AssetStatus_CreateEdit,
                  PermissionsEnum.AssetStatus_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.ASSET_STATUS.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetStatus_View])" (change)="
            onChangePermission([PermissionsEnum.AssetStatus_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetStatus_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.AssetStatus_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetStatus_Delete])" (change)="
            onChangePermission([PermissionsEnum.AssetStatus_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Meter Price -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.MeterPrice_View,
                PermissionsEnum.MeterPrice_CreateEdit,
                PermissionsEnum.MeterPrice_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.MeterPrice_View,
                  PermissionsEnum.MeterPrice_CreateEdit,
                  PermissionsEnum.MeterPrice_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.METER_PRICE.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterPrice_View])" (change)="
            onChangePermission([PermissionsEnum.MeterPrice_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterPrice_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.MeterPrice_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterPrice_Delete])" (change)="
            onChangePermission([PermissionsEnum.MeterPrice_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Dt meter type -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.DtMeterType_View,
                PermissionsEnum.DtMeterType_CreateEdit,
                PermissionsEnum.DtMeterType_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.DtMeterType_View,
                  PermissionsEnum.DtMeterType_CreateEdit,
                  PermissionsEnum.DtMeterType_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.DT_METER_TYPE.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterType_View])" (change)="
            onChangePermission([PermissionsEnum.DtMeterType_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterType_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.DtMeterType_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterType_Delete])" (change)="
            onChangePermission([PermissionsEnum.DtMeterType_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Audit log -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.AuditLog_View,
                PermissionsEnum.AuditLog_Download
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.AuditLog_View,
                  PermissionsEnum.AuditLog_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.AUDIT_LOG" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AuditLog_View])"
          (change)="onChangePermission([PermissionsEnum.AuditLog_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AuditLog_Download])" (change)="
            onChangePermission([PermissionsEnum.AuditLog_Download], $event)
          " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>

  <!-- Audit Status -->
  <div class="component" *ngIf="
      (permissionsService.hasDashboardConfigBuildings ||
        permissionsService.hasDashboardConfigBuildings ||
        permissionsService.hasDashboardConfigDTS ||
        permissionsService.hasDashboardConfigPoles) &&
      !isDisabled
    ">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.AuditStatus])"
            (change)="onChangePermission([PermissionsEnum.AuditStatus], $event)" />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.VIEW_AUDIT_STATUS" | translate }}</label>
      </div>
    </div>
  </div>

  <!-- Validation Status -->
  <div class="component" *ngIf="
      (permissionsService.hasDashboardConfigBuildings ||
        permissionsService.hasDashboardConfigBuildings ||
        permissionsService.hasDashboardConfigDTS ||
        permissionsService.hasDashboardConfigPoles) &&
      !isDisabled
    ">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.ValidationStatus])" (change)="
              onChangePermission([PermissionsEnum.ValidationStatus], $event)
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{ "COMMON.VIEW_VALIDATION_STATUS" | translate }}</label>
      </div>
    </div>
  </div>

  <!-- Review Status -->
  <div class="component" *ngIf="
      (permissionsService.hasDashboardConfigBuildings ||
        permissionsService.hasDashboardConfigCustomerManagement) &&
      !isDisabled
    ">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.ReviewStatus])"
            (change)="onChangePermission([PermissionsEnum.ReviewStatus], $event)" />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title"> {{ "COMMON.VIEW_REVIEW_STATUS" | translate }}</label>
      </div>
    </div>
  </div>

  <!-- Work Orders -->
  <div class="component" *ngIf="!isDisabled && permissionsService.hasDashboardConfigWorkOrder">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.SiteVerification || PermissionsEnum.Maintenance
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.SiteVerification ||
                    PermissionsEnum.Maintenance
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.WORK_ORDER" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification], $event)
          " />
        {{ "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate }}</label>

      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Maintenance])"
          (change)="onChangePermission([PermissionsEnum.Maintenance], $event)" />
        {{ "COMMON.MAINTENANCE" | translate }}</label>
    </div>
  </div>
  <!-- Slt Status -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Slt_View,
                PermissionsEnum.Slt_CreateEdit,
                PermissionsEnum.Slt_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Slt_View,
                  PermissionsEnum.Slt_CreateEdit,
                  PermissionsEnum.Slt_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.SLT_STATUS.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Slt_View])"
          (change)="onChangePermission([PermissionsEnum.Slt_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Slt_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Slt_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Slt_Delete])"
          (change)="onChangePermission([PermissionsEnum.Slt_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>

  <!-- Customer Meter Stock Inventory -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeterCustomers">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.CustomerMeterStockInventory_View,
                PermissionsEnum.CustomerMeterStockInventory_Create,
                PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.CustomerMeterStockInventory_View,
                  PermissionsEnum.CustomerMeterStockInventory_Create,
                  PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.MBC_DETAILS.CUSTOMER_METER_STOCK_INVENTORY" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_View])" (change)="
            onChangePermission(
              [PermissionsEnum.CustomerMeterStockInventory_View],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_Create])" (change)="
            onChangePermission(
              [PermissionsEnum.CustomerMeterStockInventory_Create],
              $event
            )
          " />
        {{ "COMMON.CREATE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock])" (change)="
            onChangePermission(
              [PermissionsEnum.CustomerMeterStockInventory_ViewUtilizationStock],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate }}</label>
    </div>
  </div>

  <!-- Asset Meter Inventory -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeterAssets">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.AssetMeterStockInventory_View,
                PermissionsEnum.AssetMeterStockInventory_Create,
                PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.AssetMeterStockInventory_View,
                  PermissionsEnum.AssetMeterStockInventory_Create,
                  PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.MBC_DETAILS.ASSET_METER_INVENTORY" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_View])" (change)="
            onChangePermission(
              [PermissionsEnum.AssetMeterStockInventory_View],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_Create])" (change)="
            onChangePermission(
              [PermissionsEnum.AssetMeterStockInventory_Create],
              $event
            )
          " />
        {{ "COMMON.CREATE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock])" (change)="
            onChangePermission(
              [PermissionsEnum.AssetMeterStockInventory_ViewUtilizationStock],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate }}</label>
    </div>
  </div>

  <!-- CT/VT Stock Inventory -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeterCtvt">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.CtvtMeterStockInventory_View,
                PermissionsEnum.CtvtMeterStockInventory_Create,
                PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.CtvtMeterStockInventory_View,
                  PermissionsEnum.CtvtMeterStockInventory_Create,
                  PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.MBC_DETAILS.CTVT_STOCK_INVENTORY" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_View])" (change)="
            onChangePermission(
              [PermissionsEnum.CtvtMeterStockInventory_View],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_Create])" (change)="
            onChangePermission(
              [PermissionsEnum.CtvtMeterStockInventory_Create],
              $event
            )
          " />
        {{ "COMMON.CREATE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock])" (change)="
            onChangePermission(
              [PermissionsEnum.CtvtMeterStockInventory_ViewUtilizationStock],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW_UTILIZATION_STOCK" | translate }}</label>
    </div>
  </div>

  <!-- Customer Decommissioned Meter Stock -->
  <div class="component" *ngIf="permissionsService.hasAnyMeterManagement">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.CustomerDecommissionedMeterStock_View,
                PermissionsEnum.CustomerDecommissionedMeterStock_Approve
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.CustomerDecommissionedMeterStock_View,
                  PermissionsEnum.CustomerDecommissionedMeterStock_Approve
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.MBC_DETAILS.CUSTOMER_DECOMMISSIONED_METER_STOCK" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_View])" (change)="
            onChangePermission(
              [PermissionsEnum.CustomerDecommissionedMeterStock_View],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="
            isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_Approve])
          " (change)="
            onChangePermission(
              [PermissionsEnum.CustomerDecommissionedMeterStock_Approve],
              $event
            )
          " />
        Approve</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.CustomerDecommissionedMeterStock_Edit])" (change)="
            onChangePermission(
              [PermissionsEnum.CustomerDecommissionedMeterStock_Edit],
              $event
            )
          " />
        {{ "COMMON.EDIT" | translate }}</label>
    </div>
  </div>

  <!-- Meter Price -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigReadings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.BillingAccounts_View,
                PermissionsEnum.BillingAccounts_CreateEdit,
                PermissionsEnum.BillingAccounts_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.BillingAccounts_View,
                  PermissionsEnum.BillingAccounts_CreateEdit,
                  PermissionsEnum.BillingAccounts_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.BILLING_ACCOUNTS.PLURAL" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.BillingAccounts_View])" (change)="
            onChangePermission([PermissionsEnum.BillingAccounts_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.BillingAccounts_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.BillingAccounts_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.BillingAccounts_Delete])" (change)="
            onChangePermission([PermissionsEnum.BillingAccounts_Delete], $event)
          " />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>

  <!-- Network Structure -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNetworkModelStructure">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.NetworkStructure_View,
              PermissionsEnum.NetworkStructure_CreateEdit,
              PermissionsEnum.NetworkStructure_Assign,
              PermissionsEnum.NetworkStructure_ApproveReject,
              PermissionsEnum.NetworkStructure_Review,
              PermissionsEnum.NetworkStructure_AuditReview,
              PermissionsEnum.NetworkStructure_GisReview,
              PermissionsEnum.NetworkStructure_RecallValidated,
              PermissionsEnum.NetworkStructure_RecallAssigned,
              PermissionsEnum.NetworkStructure_Download,
              PermissionsEnum.NetworkStructure_Delete
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.NetworkStructure_View,
                PermissionsEnum.NetworkStructure_CreateEdit,
                PermissionsEnum.NetworkStructure_Assign,
                PermissionsEnum.NetworkStructure_ApproveReject,
                PermissionsEnum.NetworkStructure_Review,
                PermissionsEnum.NetworkStructure_AuditReview,
                PermissionsEnum.NetworkStructure_GisReview,
                PermissionsEnum.NetworkStructure_RecallValidated,
                PermissionsEnum.NetworkStructure_RecallAssigned,
                PermissionsEnum.NetworkStructure_Download,
                PermissionsEnum.NetworkStructure_Delete          
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.NETWORK_STRUCTURE' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_View])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_CreateEdit])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_CreateEdit], $event)
        " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_Delete])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_Delete], $event)
        " />
        {{ "ROLE_MANAGEMENT.DELETE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_Assign])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_Assign], $event)
        " />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_ApproveReject])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_ApproveReject], $event)
        " />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_Review])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_Review], $event)
        " />
        {{ "ROLE_MANAGEMENT.REVIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_AuditReview])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_AuditReview], $event)
        " />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_GisReview])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_GisReview], $event)
        " />
        {{ "ROLE_MANAGEMENT.GIS_REVIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_RecallValidated])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_RecallValidated], $event)
        " />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_RecallAssigned])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_RecallAssigned], $event)
        " />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkStructure_Download])" (change)="
          onChangePermission([PermissionsEnum.NetworkStructure_Download], $event)
        " />
        {{ "ROLE_MANAGEMENT.DOWNLOAD" | translate }}</label>
    </div>
  </div>

  <!-- Schematic Diagram -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.SchematicDiagram_View,
              PermissionsEnum.SchematicDiagram_CreateEdit
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.SchematicDiagram_View,
                PermissionsEnum.SchematicDiagram_CreateEdit
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'UTILITY_MANAGEMENT.SCHEMATIC_DIAGRAM' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SchematicDiagram_View])" (change)="
          onChangePermission([PermissionsEnum.SchematicDiagram_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SchematicDiagram_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.SchematicDiagram_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
    </div>
  </div>

  <!-- Network Entity Classes -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigNetworkEntityClassInstantiation">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.NetworkEntityClasses_View,
              PermissionsEnum.NetworkEntityClasses_CreateEdit,
              PermissionsEnum.NetworkEntityClasses_Delete
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.NetworkEntityClasses_View,
                PermissionsEnum.NetworkEntityClasses_CreateEdit,
                PermissionsEnum.NetworkEntityClasses_Delete          
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.NETWORK_ENTITY_CLASSES' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_View])" (change)="
          onChangePermission([PermissionsEnum.NetworkEntityClasses_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.NetworkEntityClasses_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.NetworkEntityClasses_Delete])"
          (change)="onChangePermission([PermissionsEnum.NetworkEntityClasses_Delete], $event)" />
        {{ "ROLE_MANAGEMENT.DELETE" | translate }}</label>
    </div>
  </div>

  <!-- Data Model Customization -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigDataModelCustomization">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.DataModelCustomization_View
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.DataModelCustomization_View           
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.DATA_MODEL_CUSTOMIZATION' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DataModelCustomization_View])" (change)="
          onChangePermission([PermissionsEnum.DataModelCustomization_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
    </div>
  </div>
  <!-- Payment History -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigPaymentHistory">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.PaymentHistory_View,
              PermissionsEnum.PaymentHistory_Download
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.PaymentHistory_View,
                PermissionsEnum.PaymentHistory_Download
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'SIDENAV.PAYMENT_HISTORY' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.PaymentHistory_View])" (change)="
          onChangePermission([PermissionsEnum.PaymentHistory_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.PaymentHistory_Download])" (change)="
          onChangePermission([PermissionsEnum.PaymentHistory_Download], $event)
        " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- Settlement -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigSettlement">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.Settlement_View,
              PermissionsEnum.Settlement_Download
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.Settlement_View,
                PermissionsEnum.Settlement_Download
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'PAYMENT_HISTORY.TAB_SETTLEMENTS' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Settlement_View])" (change)="
          onChangePermission([PermissionsEnum.Settlement_View], $event)
        " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Settlement_Download])" (change)="
          onChangePermission([PermissionsEnum.Settlement_Download], $event)
        " />
        {{ "COMMON.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- Meter Assignment -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.MeterAssignment_View,
                PermissionsEnum.MeterAssignment_CreateEdit,
                PermissionsEnum.MeterAssignment_Delete
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.MeterAssignment_View,
                  PermissionsEnum.MeterAssignment_CreateEdit,
                  PermissionsEnum.MeterAssignment_Delete
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.METER_ASSIGNMENT.SINGLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterAssignment_View])"
          (change)="onChangePermission([PermissionsEnum.MeterAssignment_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterAssignment_CreateEdit])"
          (change)="onChangePermission([PermissionsEnum.MeterAssignment_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterAssignment_Delete])"
          (change)="onChangePermission([PermissionsEnum.MeterAssignment_Delete], $event)" />
        {{ "COMMON.DELETE" | translate }}</label>
    </div>
  </div>
  <!-- Audit Trail -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
            isChecked([
              PermissionsEnum.AuditTrail_View,
              PermissionsEnum.AuditTrail_Download
            ])
          " (change)="
            onChangePermission(
              [
                PermissionsEnum.AuditTrail_View,
                PermissionsEnum.AuditTrail_Download           
              ],
              $event
            )
          " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">
          {{'AUDIT_TRAIL.NAME' | translate }}
        </label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AuditTrail_View])"
          (change)="onChangePermission([PermissionsEnum.AuditTrail_View], $event)" />
        {{ "AUDIT_TRAIL.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AuditTrail_Download])"
          (change)="onChangePermission([PermissionsEnum.AuditTrail_Download], $event)" />
        {{ "AUDIT_TRAIL.DOWNLOAD" | translate }}</label>
    </div>
  </div>
  <!-- AI Chat -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigAiWidget">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.AiChat_Use
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.AiChat_Use
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "CHAT_AI.TITLE" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.AiChat_Use])" (change)="
            onChangePermission([PermissionsEnum.AiChat_Use], $event)
          " />
        {{ "CHAT_AI.USE" | translate }}</label>
    </div>
  </div>
</div>

<div *ngIf="isMobile" [ngClass]="{
    'disable-div': !permissionsService.isRoleManagementCreateEditAllowed
  }">
  <!-- Customers -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigBuildings && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Customer_View,
                PermissionsEnum.Customer_CreateEdit,
                PermissionsEnum.Customer_Retag,
                PermissionsEnum.Customer_Sweep
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Customer_View,
                  PermissionsEnum.Customer_CreateEdit,
                  PermissionsEnum.Customer_Retag,
                  PermissionsEnum.Customer_Sweep
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.CUSTOMER.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_View])"
          (change)="onChangePermission([PermissionsEnum.Customer_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Customer_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_Retag])" (change)="
            onChangePermission([PermissionsEnum.Customer_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label *ngIf="isRegularizationUploadVisible"><input type="checkbox"
          [checked]="isChecked([PermissionsEnum.Customer_Regularization])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_Regularization],
              $event
            )
          " />
        {{ "COMMON.REGULARIZATION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_Sweep])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_Sweep],
              $event
            )
          " />
        {{ "COMMON.SWEEP" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Customer_GlobalView])" (change)="
            onChangePermission(
              [PermissionsEnum.Customer_GlobalView],
              $event
            )
          " />
        {{ "COMMON.GLOBAL_VIEW" | translate }}</label>
    </div>
  </div>
  <!-- DT -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigDTS && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Transformers_View,
                PermissionsEnum.Transformers_CreateEdit,
                PermissionsEnum.Transformers_Retag
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Transformers_View,
                  PermissionsEnum.Transformers_CreateEdit,
                  PermissionsEnum.Transformers_Retag
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.TRANSFORMER.PLURAL" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_View])" (change)="
            onChangePermission([PermissionsEnum.Transformers_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Transformers_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Transformers_Retag])" (change)="
            onChangePermission([PermissionsEnum.Transformers_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
    </div>
  </div>

  <!-- Rmus -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigRmus && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Rmus_View,
                PermissionsEnum.Rmus_CreateEdit,
                PermissionsEnum.Rmus_Retag
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Rmus_View,
                  PermissionsEnum.Rmus_CreateEdit,
                  PermissionsEnum.Rmus_Retag
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "RMU.PLURAL" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_View])" (change)="
            onChangePermission([PermissionsEnum.Rmus_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Rmus_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Rmus_Retag])" (change)="
            onChangePermission([PermissionsEnum.Rmus_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
    </div>
  </div>
  <!-- Poles -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigPoles && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Pole_View,
                PermissionsEnum.Pole_CreateEdit,
                PermissionsEnum.Pole_Retag,
                PermissionsEnum.Pole_Sweep

              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Pole_View,
                  PermissionsEnum.Pole_CreateEdit,
                  PermissionsEnum.Pole_Retag,
                  PermissionsEnum.Pole_Sweep
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.POLE.LV_POLES" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_View])"
          (change)="onChangePermission([PermissionsEnum.Pole_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Pole_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_Retag])"
          (change)="onChangePermission([PermissionsEnum.Pole_Retag], $event)" />
        {{ "COMMON.RETAG" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Pole_Sweep])"
          (change)="onChangePermission([PermissionsEnum.Pole_Sweep], $event)" />
        {{ "COMMON.SWEEP" | translate }}</label>
    </div>
  </div>
  <!-- MV Poles -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMVPoles && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.MVPole_View,
                PermissionsEnum.MVPole_CreateEdit,
                PermissionsEnum.MVPole_Delete,
                PermissionsEnum.MVPole_Assign,
                PermissionsEnum.MVPole_ApproveReject,
                PermissionsEnum.MVPole_AuditReview,
                PermissionsEnum.MVPole_RecallAssigned,
                PermissionsEnum.MVPole_Retag,
                PermissionsEnum.MVPole_RecallValidated,
                PermissionsEnum.MVPole_Download

              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.MVPole_View,
                  PermissionsEnum.MVPole_CreateEdit,
                  PermissionsEnum.MVPole_Delete,
                  PermissionsEnum.MVPole_Assign,
                  PermissionsEnum.MVPole_ApproveReject,
                  PermissionsEnum.MVPole_AuditReview,
                  PermissionsEnum.MVPole_RecallAssigned,
                  PermissionsEnum.MVPole_Retag,
                  PermissionsEnum.MVPole_RecallValidated,
                  PermissionsEnum.MVPole_Download
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">MV Poles</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_View])"
          (change)="onChangePermission([PermissionsEnum.MVPole_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_CreateEdit])"
          (change)="onChangePermission([PermissionsEnum.MVPole_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Delete])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Delete], $event)" />
        {{ "ROLE_MANAGEMENT.DELETE" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Assign])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Assign], $event)" />
        {{ "ROLE_MANAGEMENT.ASSIGN" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_ApproveReject])"
          (change)="onChangePermission([PermissionsEnum.MVPole_ApproveReject], $event)" />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_AuditReview])"
          (change)="onChangePermission([PermissionsEnum.MVPole_AuditReview], $event)" />
        {{ "ROLE_MANAGEMENT.AUDIT_REVIEW" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_RecallAssigned])"
          (change)="onChangePermission([PermissionsEnum.MVPole_RecallAssigned], $event)" />
        {{ "ROLE_MANAGEMENT.RECALL_ASSIGNED" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Retag])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Retag], $event)" />
        {{ "ROLE_MANAGEMENT.RETAG" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_RecallValidated])"
          (change)="onChangePermission([PermissionsEnum.MVPole_RecallValidated], $event)" />
        {{ "ROLE_MANAGEMENT.RECALL_VALIDATED" | translate }}
      </label>
      <label>
        <input type="checkbox" [checked]="isChecked([PermissionsEnum.MVPole_Download])"
          (change)="onChangePermission([PermissionsEnum.MVPole_Download], $event)" />
        {{ "ROLE_MANAGEMENT.DOWNLOAD" | translate }}
      </label>
    </div>
  </div>
  <!-- Buildings -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigBuildings && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Building_View,
                PermissionsEnum.Building_CreateEdit,
                PermissionsEnum.Building_Retag,
                PermissionsEnum.Building_Sweep
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Building_View,
                  PermissionsEnum.Building_CreateEdit,
                  PermissionsEnum.Building_Retag,
                  PermissionsEnum.Building_Sweep
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.BUILDING.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_View])"
          (change)="onChangePermission([PermissionsEnum.Building_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Building_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_Retag])" (change)="
            onChangePermission([PermissionsEnum.Building_Retag], $event)
          " />
        {{ "COMMON.RETAG" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Building_Sweep])" (change)="
          onChangePermission([PermissionsEnum.Building_Sweep], $event)
        " />
        {{ "COMMON.SWEEP" | translate }}</label>
    </div>
  </div>
  <!-- Meters -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeters && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Meters_View,
                PermissionsEnum.Meters_CreateEdit,
                PermissionsEnum.Meters_Retag
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Meters_View,
                  PermissionsEnum.Meters_CreateEdit,
                  PermissionsEnum.Meters_Retag
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "METERS.PLURAL" | translate }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_View])"
          (change)="onChangePermission([PermissionsEnum.Meters_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Meters_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meters_Retag])"
          (change)="onChangePermission([PermissionsEnum.Meters_Retag], $event)" />
        {{ "COMMON.RETAG" | translate }}</label>
    </div>
  </div>
  <!-- Survey -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigSurvey && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Survey_View,
                PermissionsEnum.Survey_CreateEdit,
                PermissionsEnum.Survey_Create_New,
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Survey_View,
                  PermissionsEnum.Survey_CreateEdit,
                  PermissionsEnum.Survey_Create_New,
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "DASHBOARD.OPERATIONS_ANALYTICS.SURVEYS" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_View])"
          (change)="onChangePermission([PermissionsEnum.Survey_View], $event)" />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.Survey_CreateEdit], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Survey_Create_New])" (change)="
            onChangePermission([PermissionsEnum.Survey_Create_New], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_NEW" | translate }}</label>
    </div>
  </div>

  <!-- Customer Installation -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigInstallation && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Installation_View,
                PermissionsEnum.Installation_CreateEdit
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Installation_View,
                  PermissionsEnum.Installation_CreateEdit
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.CUSTOMER_INSTALLATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_View])" (change)="
            onChangePermission([PermissionsEnum.Installation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Installation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Installation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
    </div>
  </div>

  <!-- DT Meter Installation (Mobile) -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigDtMeterInstallation && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.DtMeterInstallation_View,
                PermissionsEnum.DtMeterInstallation_CreateEdit,
                PermissionsEnum.DtMeterInstallation_CreateNew
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.DtMeterInstallation_View,
                  PermissionsEnum.DtMeterInstallation_CreateEdit,
                  PermissionsEnum.DtMeterInstallation_CreateNew
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.DT_METER_INSTALLATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_View])" (change)="
            onChangePermission([PermissionsEnum.DtMeterInstallation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.DtMeterInstallation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.DtMeterInstallation_CreateNew])" (change)="
            onChangePermission([PermissionsEnum.DtMeterInstallation_CreateNew], $event)
          " />
        {{ "ROLE_MANAGEMENT.CREATE_NEW" | translate }}</label>
    </div>
  </div>
  <!-- Meter Validation -->
  <div class="component" *ngIf="permissionsService.hasDashboardConfigMeterValidation && !isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Meter_Validation_View,
                PermissionsEnum.Meter_Validation_CreateEdit
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.Meter_Validation_View,
                  PermissionsEnum.Meter_Validation_CreateEdit
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "SIDENAV.METER_VALIDATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meter_Validation_View])" (change)="
            onChangePermission([PermissionsEnum.Meter_Validation_View], $event)
          " />
        {{ "ROLE_MANAGEMENT.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Meter_Validation_CreateEdit])" (change)="
            onChangePermission(
              [PermissionsEnum.Meter_Validation_CreateEdit],
              $event
            )
          " />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
    </div>
  </div>
  <!-- Work Orders -->
  <div class="component" *ngIf="!isDisabled && permissionsService.hasDashboardConfigWorkOrder">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.Maintenance,
                PermissionsEnum.Disconnection,
                PermissionsEnum.Outages,
              ])
            " (change)="
              onChangePermission(
                [PermissionsEnum.Maintenance,
                PermissionsEnum.Disconnection,
                PermissionsEnum.Outages],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.WORK_ORDER" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Maintenance])"
          (change)="onChangePermission([PermissionsEnum.Maintenance], $event)" />
        {{ "COMMON.MAINTENANCE" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Disconnection])" (change)="
            onChangePermission([PermissionsEnum.Disconnection], $event)
          " />
        {{ "COMMON.DISCONNECTION" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.Outages])"
          (change)="onChangePermission([PermissionsEnum.Outages], $event)" />
        {{ "COMMON.OUTAGES" | translate }}</label>
    </div>
  </div>

  <!-- Site Verification -->
  <div class="component" *ngIf="!isDisabled">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="
              isChecked([
                PermissionsEnum.SiteVerification_View,
                PermissionsEnum.SiteVerification_CreateEdit,
                PermissionsEnum.SiteVerification_ApproveReject,
              ])
            " (change)="
              onChangePermission(
                [
                  PermissionsEnum.SiteVerification_View,
                  PermissionsEnum.SiteVerification_CreateEdit,
                  PermissionsEnum.SiteVerification_ApproveReject
                ],
                $event
              )
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "ROLE_MANAGEMENT.SITE_VERIFICATION" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_View])"
          (change)="onChangePermission([PermissionsEnum.SiteVerification_View], $event)" />
        {{ "COMMON.VIEW" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_CreateEdit])" (change)="
            onChangePermission([PermissionsEnum.SiteVerification_CreateEdit], $event)" />
        {{ "ROLE_MANAGEMENT.CREATE_EDIT" | translate }}</label>
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SiteVerification_ApproveReject])"
          (change)="onChangePermission([PermissionsEnum.SiteVerification_ApproveReject], $event)" />
        {{ "ROLE_MANAGEMENT.APPROVE_REJECT" | translate }}</label>
    </div>
  </div>

  <!-- Meter Readings -->
  <div class="component" *ngIf="!isDisabled && permissionsService.hasDashboardConfigReadings">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterReading])" (change)="
              onChangePermission([PermissionsEnum.MeterReading], $event)
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.MBC_DETAILS.METER_READINGS" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.MeterReading])"
          (change)="onChangePermission([PermissionsEnum.MeterReading], $event)" />
        {{ "COMMON.MBC_DETAILS.METER_READING" | translate }}</label>
    </div>
  </div>

  <!-- Assignment -->
  <!-- <div class="component" *ngIf="isChecked([PermissionsEnum.Disconnection])">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.Disconnection])" />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.DISCONNECTION" | translate }}</label>
      </div>
    </div>
  </div> -->

  <!-- Outages -->
  <!-- <div class="component" *ngIf="isChecked([PermissionsEnum.Outages])">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.Outages])" />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{ "COMMON.ADORA" | translate }}
          {{ "ROLE_MANAGEMENT.WORK_ORDER" | translate }}</label>
      </div>
    </div>
  </div> -->

  <!-- Search Engine -->
  <div class="component">
    <div class="headerComponent">
      <div>
        <label class="switch">
          <input type="checkbox" [checked]="isChecked([PermissionsEnum.SearchEngine])" (change)="
              onChangePermission([PermissionsEnum.SearchEngine], $event)
            " />
          <span class="slider round"></span>
        </label>
      </div>
      <div>
        <label class="title">{{
          "COMMON.SEARCH_ENGINE" | translate
          }}</label>
      </div>
    </div>
    <div class="permissionsComponent">
      <label><input type="checkbox" [checked]="isChecked([PermissionsEnum.SearchEngine])"
          (change)="onChangePermission([PermissionsEnum.SearchEngine], $event)" />
        {{ "COMMON.SEARCH_ENGINE" | translate }}</label>
    </div>
  </div>
</div>